export default __webpack_public_path__ + "static/media/profile.e9cced30.jpg";